import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

const PRIVACY_POLICY_URL =
  "/docs/politica-tratamiento-proteccion-datos-personales.html";

const Footer = () => {
  const [openSection, setOpenSection] = useState(null);

  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section);
  };

  const renderItem = (item, index) => {
    if (typeof item === "string") {
      return (
        <li key={index} className="list-disc">
          {item}
        </li>
      );
    }

    return (
      <li key={index} className="list-disc">
        <a
          href={item.href}
          target={item.external ? "_blank" : undefined}
          rel={item.external ? "noopener noreferrer" : undefined}
          className="text-green-700 hover:underline"
        >
          {item.label}
        </a>
      </li>
    );
  };

  const Section = ({ title, id, items }) => (
    <div className="space-y-4">
      <button
        onClick={() => toggleSection(id)}
        className="flex justify-between items-center w-full font-semibold text-left text-gray-800 transition-colors hover:text-green-700"
      >
        {title}
        <ChevronDown
          className={`ml-2 transition-transform duration-300 ${
            openSection === id ? "rotate-180" : ""
          }`}
          size={18}
        />
      </button>

      <div
        className={`pl-3 pr-1 overflow-hidden transition-all duration-300 ease-in-out text-sm text-gray-600 ${
          openSection === id ? "max-h-[1000px] opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        {id === "ayuda" ? (
          <ul className="space-y-2 leading-relaxed text-[15px] ml-4">
            <li>
              <a
                href="mailto:soporte@docentia.com.co"
                className="text-green-700 hover:underline"
              >
                soporte@docentia.com.co
              </a>
            </li>
            <li>
              <a
                href="https://wa.me/573001234567"
                target="_blank"
                rel="noopener noreferrer"
                className="text-green-700 hover:underline"
              >
                WhatsApp: +57 300 123 4567
              </a>
            </li>
            <li>
              <a
                href="tel:+573001234567"
                className="text-green-700 hover:underline"
              >
                Teléfono: +57 300 123 4567
              </a>
            </li>
          </ul>
        ) : (
          <ul className="space-y-2 leading-relaxed text-[15px] ml-4">
            {items.map((item, index) => renderItem(item, index))}
          </ul>
        )}
      </div>
    </div>
  );

  return (
    <footer className="px-6 py-10 text-black bg-gray-100 md:px-20">
      <div className="grid grid-cols-2 gap-10 mx-auto max-w-7xl text-sm md:grid-cols-4">
        <Section
          title="Consigue la aplicación"
          id="app"
          items={[
            "Disponible en App Store",
            "Disponible en Google Play",
          ]}
        />
        <Section
          title="¿Quiénes somos?"
          id="quienes"
          items={[
            "Megalabs Colombia es una empresa farmacéutica de origen latinoamericano que opera en 18 países y se enfoca en el desarrollo y producción de medicamentos seguros, confiables y accesibles para mejorar la calidad de vida de las personas.",
          ]}
        />
        <Section title="Ayuda y asistencia" id="ayuda" items={[]} />
        <Section
          title="Condiciones"
          id="condiciones"
          items={[
            "Términos y condiciones de uso",
            "Aviso legal",
            "Política de devoluciones",
          ]}
        />
        <Section
          title="Política de privacidad"
          id="privacidad"
          items={[
            {
              label: "Tratamiento y protección de datos personales",
              href: PRIVACY_POLICY_URL,
              external: true,
            },
            {
              label: "Cómo protegemos tus datos",
              href: PRIVACY_POLICY_URL,
              external: true,
            },
            {
              label: "Información compartida con terceros",
              href: PRIVACY_POLICY_URL,
              external: true,
            },
            {
              label: "Derechos del usuario",
              href: PRIVACY_POLICY_URL,
              external: true,
            },
          ]}
        />
        <Section
          title="Configuración de cookies"
          id="cookies"
          items={[
            "Aceptar todas las cookies",
            "Rechazar cookies no esenciales",
            "Configurar preferencias de cookies",
          ]}
        />
      </div>

      {/* Línea inferior con logo */}
      <div className="flex flex-col justify-between items-center pt-6 mt-12 text-sm text-gray-600 border-t border-gray-300 md:flex-row">
        <div className="flex gap-3 items-center font-semibold text-green-600">
          <img
            src="/img/logomega.png"
            alt="Logo Megalabs"
            className="w-auto max-w-none h-12"
          />
        </div>
        <p className="mt-4 text-center md:mt-0">
          &copy; {new Date().getFullYear()} Megalabs Colombia S.A.S Todos los derechos reservados.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
